import React from "react";

export const BrandMark = ({ size = 48, className = "" }) => {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-mark">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="31" fill="#FDFBF7" stroke="#C5A059" strokeWidth="1" />
        {/* Maple leaf silhouette in blush */}
        <path
          d="M32 12 L34.5 20 L42 18 L38 25 L46 27 L38.5 32 L44 39 L36 38 L36.5 46 L32 41 L27.5 46 L28 38 L20 39 L25.5 32 L18 27 L26 25 L22 18 L29.5 20 Z"
          fill="#E8B4B8"
          stroke="#D9A0A5"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <circle cx="32" cy="32" r="2" fill="#C5A059" />
      </svg>
    </div>
  );
};

export default BrandMark;
